import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

const Basis = Loadable(lazy(() => import('views/basis/Single')));
const BasisJoin = Loadable(lazy(() => import('views/basis/Join')));
const UserList = Loadable(lazy(() => import('views/userList')));
const User = Loadable(lazy(() => import('views/user')));
const UserSingle = Loadable(lazy(() => import('views/user/Single')));
const UserGroupSingle = Loadable(lazy(() => import('views/userGroup/Single')));
const Upgrade = Loadable(lazy(() => import('views/upgrade')));
const Task = Loadable(lazy(() => import('views/task')));
const TaskSingle = Loadable(lazy(() => import('views/task/Single')));
//const TaskStatus = Loadable(lazy(() => import('views/taskStatus')));
//const TaskStatusSingle = Loadable(lazy(() => import('views/taskStatus/Single')));
const Department = Loadable(lazy(() => import('views/department')));
const DepartmentSingle = Loadable(lazy(() => import('views/department/Single')));
const Fund = Loadable(lazy(() => import('views/fund')));
const Receipt = Loadable(lazy(() => import('views/receipt')));
const ReceiptSingle = Loadable(lazy(() => import('views/receipt/Single')));
const Reference = Loadable(lazy(() => import('views/reference')));
const ReferenceSingle = Loadable(lazy(() => import('views/reference/Single')));
const Cheque = Loadable(lazy(() => import('views/cheque')));
const ChequeSingle = Loadable(lazy(() => import('views/cheque/Single')));
const ChequeStatus = Loadable(lazy(() => import('views/chequeStatus')));
const ChequeStatusSingle = Loadable(lazy(() => import('views/chequeStatus/Single')));
const Bank = Loadable(lazy(() => import('views/bank')));
const BankSingle = Loadable(lazy(() => import('views/bank/Single')));
const Rental = Loadable(lazy(() => import('views/rental')));
const RentalSingle = Loadable(lazy(() => import('views/rental/Single')));
const Renter = Loadable(lazy(() => import('views/renter')));
const RenterSingle = Loadable(lazy(() => import('views/renter/Single')));
const Report = Loadable(lazy(() => import('views/report')));
const ReportReceipt = Loadable(lazy(() => import('views/report/Receipts')));
const ReportDesigner = Loadable(lazy(() => import('views/report/Designer')));
const ReportPrint = Loadable(lazy(() => import('views/report/Print')));
const Profile = Loadable(lazy(() => import('views/profile')));
const Payment = Loadable(lazy(() => import('views/payment')));
const PaymentSingle = Loadable(lazy(() => import('views/payment/Single')));
const Chat = Loadable(lazy(() => import('views/chat')));
const ChatSingle = Loadable(lazy(() => import('views/chat/Single')));
const Object = Loadable(lazy(() => import('views/object')));
const ObjectSingle = Loadable(lazy(() => import('views/object/Single')));
const Tel = Loadable(lazy(() => import('views/contact/tel')));
const Social = Loadable(lazy(() => import('views/contact/social')));
const About = Loadable(lazy(() => import('views/features/about')));
const Terms = Loadable(lazy(() => import('views/features/terms')));
const Share = Loadable(lazy(() => import('views/features/share')));
const Rate = Loadable(lazy(() => import('views/features/rate')));
const Faq = Loadable(lazy(() => import('views/features/faq')));
const Wallet = Loadable(lazy(() => import('views/wallet')));
const Account = Loadable(lazy(() => import('views/account')));
const Splash = Loadable(lazy(() => import('views/pages/Splash')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <Splash width="256px" height="256px" />
        },
        {
            path: '*',
            element: <DashboardDefault />
        },
        {
            path: '/dashboard',
            element: <DashboardDefault />
        },
        {
            path: '/basis/:basisId',
            element: <Basis />
        },
        {
            path: '/basis/:basisId/user',
            element: <UserList />
        },
        {
            path: '/basis/:basisId/users',
            element: <User />
        },
        {
            path: '/basis/:basisId/user/:userId',
            element: <UserSingle />
        },
        {
            path: '/basis/:basisId/user_group/:userGroupId',
            element: <UserGroupSingle />
        },
        {
            path: '/basis/:basisId/upgrade',
            element: <Upgrade />
        },
        {
            path: '/basis/:basisId/tasks',
            element: <Task />
        },
        {
            path: '/basis/:basisId/task/:taskId',
            element: <TaskSingle />
        },
        {
            path: '/basis/:basisId/departments',
            element: <Department />
        },
        {
            path: '/basis/:basisId/department/:departmentId',
            element: <DepartmentSingle />
        },
        {
            path: '/basis/:basisId/accounts',
            element: <Account />
        },
        {
            path: '/basis/:basisId/funds',
            element: <Fund />
        },
        {
            path: '/receipts',
            element: <Receipt />
        },
        {
            path: '/basis/:basisId/receipts',
            element: <Receipt />
        },
        {
            path: '/basis/:basisId/receipt/:receiptId',
            element: <ReceiptSingle />
        },
        {
            path: '/basis/:basisId/references',
            element: <Reference />
        },
        {
            path: '/basis/:basisId/reference/:referenceId',
            element: <ReferenceSingle />
        },
        {
            path: '/basis/:basisId/cheques',
            element: <Cheque />
        },
        {
            path: '/basis/:basisId/cheque/:chequeId',
            element: <ChequeSingle />
        },
        {
            path: '/basis/:basisId/cheque_statuses',
            element: <ChequeStatus />
        },
        {
            path: '/basis/:basisId/cheque_status/:chequeStatusId',
            element: <ChequeStatusSingle />
        },
        {
            path: '/basis/:basisId/banks',
            element: <Bank />
        },
        {
            path: '/basis/:basisId/bank/:bankId',
            element: <BankSingle />
        },
        {
            path: '/basis/:basisId/rentals',
            element: <Rental />
        },
        {
            path: '/basis/:basisId/rental/:rentalId',
            element: <RentalSingle />
        },
        {
            path: '/basis/:basisId/renters',
            element: <Renter />
        },
        {
            path: '/basis/:basisId/renter/:renterId',
            element: <RenterSingle />
        },
        {
            path: '/basis/:basisId/reports',
            element: <Report />
        },
        {
            path: '/basis/:basisId/reports/receipt',
            element: <ReportReceipt />
        },
        {
            path: '/basis/:basisId/report_designer',
            element: <ReportDesigner />
        },
        {
            path: '/basis/:basisId/report_designer/:repName',
            element: <ReportDesigner />
        },
        {
            path: '/basis/:basisId/report_print',
            element: <ReportPrint />
        },
        {
            path: '/basis/:basisId/report_print/:repName',
            element: <ReportPrint />
        },
        {
            path: '/chats',
            element: <Chat />
        },
        {
            path: '/chat/:chatId',
            element: <ChatSingle />
        },
        {
            path: '/objects',
            element: <Object />
        },
        {
            path: '/object/:objectId',
            element: <ObjectSingle />
        },
        {
            path: '/profile',
            element: <Profile />
        },
        {
            path: '/profile/:userId',
            element: <Profile />
        },
        {
            path: '/basis/:basisId/payments',
            element: <Payment />
        },
        {
            path: '/basis/:basisId/payment/:paymentId',
            element: <PaymentSingle />
        },
        {
            path: '/social',
            element: <Social />
        },
        {
            path: '/tel',
            element: <Tel />
        },
        {
            path: '/about',
            element: <About />
        },
        {
            path: '/terms',
            element: <Terms />
        },
        {
            path: '/share',
            element: <Share />
        },
        {
            path: '/rate',
            element: <Rate />
        },
        {
            path: '/faq',
            element: <Faq />
        },
        {
            path: '/wallet',
            element: <Wallet />
        },
        {
            path: '/account',
            element: <Account />
        }
    ]
};

export default MainRoutes;
